import PageHeader from '../commons/PageHeader';
import EventSearchField from './EventSearchField';
import EventSearchResult from './EventSearchResult';
import { Container, Divider } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { useNavigate } from 'react-router-dom';
import {
  loadEvent,
  selectStatus,
  selectEvent,
  selectErrorMessage,
  resetEventState,
} from '../../app/slices/eventsSlice';
import { useEffect, useState } from 'react';

function EventSearch() {
  const dispatch = useAppDispatch();
  const { status } = useAppSelector(selectStatus);
  const event = useAppSelector(selectEvent);
  const errorMessage = useAppSelector(selectErrorMessage);
  const navigate = useNavigate();
  const [initialized, setInitialized] = useState(false);
  const [resultTitle, setResultTitle] = useState('Welcome!');
  const [resultContent, setResultContent] = useState(
    'To begin, use the search bar above to find an event by Event ID.'
  );

  useEffect(() => {
    if (!initialized) {
      setInitialized(true);

      if (event) {
        dispatch(resetEventState());
      }
      return;
    }

    if (status === 'SUCCESS') {
      navigate('event-details/' + event?.eventId);
    }

    if (status === 'FAILED') {
      setResultTitle('No Results');
      setResultContent('Please double check your Event ID and try again.');
    }
  }, [event, status, initialized, navigate, dispatch]);

  const searchEvents = (eventId: string) => {
    if (eventId.length === 0) {
      alert('Please enter eventID');
      return;
    }

    dispatch(loadEvent(eventId));
  };

  return (
    <>
      <PageHeader title='Find an event' />
      <Container sx={{ textAlign: 'left' }}>
        <EventSearchField
          searchEvents={searchEvents}
          loading={status === 'LOADING'}
          error={status === 'FAILED'}
        />
        <Divider sx={{ my: 4 }} />
        <EventSearchResult
          title={resultTitle}
          content={resultContent}
          message={errorMessage || ''}
        />
      </Container>
    </>
  );
}

export default EventSearch;
